/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */

/* Components */
import UCModal from "../../ucmodal";
import Content from "./content";

/* Styles */
import styles from "./styles";

const ConfirmAssignModal = ({showModal, setShowModal, modalIcon, modalTitle, modalDescription, handleConfirm, handleCancelConfirm, modalContent}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
      <UCModal
        className={ classes.confirmAssignModal }
        showModal={ showModal }
        setShowModal={ setShowModal }
        modalIcon={ modalIcon }
        modalTitle= { modalTitle }
        modalDescription={ modalDescription}
        modalContent={ <Content handleConfirm={handleConfirm} handleCancelConfirm={handleCancelConfirm} modalContent={modalContent}/> }
        dataTestId="confirmAssignModal"
      />
  )
}

export default ConfirmAssignModal;
